import { useSyncExternalStore } from "react";

let scaleGizmoVisible = false;
const listeners = new Set();

const emit = () => {
  listeners.forEach((listener) => {
    try {
      listener();
    } catch {
      // ignore listener failures
    }
  });
};

const dispatchSceneEvent = (visible) => {
  if (typeof window === "undefined") return;
  try {
    window.dispatchEvent(new CustomEvent("scale-gizmo-visibility", { detail: { visible } }));
  } catch {
    // ignore
  }
};

export const getScaleGizmoVisible = () => scaleGizmoVisible;

export const setScaleGizmoVisible = (nextVisible) => {
  const next = !!nextVisible;
  if (scaleGizmoVisible === next) return next;
  scaleGizmoVisible = next;
  dispatchSceneEvent(next);
  emit();
  return next;
};

export const subscribeScaleGizmoVisible = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const useScaleGizmoVisibility = () => {
  const visible = useSyncExternalStore(
    subscribeScaleGizmoVisible,
    getScaleGizmoVisible,
    getScaleGizmoVisible
  );
  return [visible, setScaleGizmoVisible];
};
